import React, { Fragment, useRef } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, Label, FormGroup, Input } from "reactstrap"
import { DefaultColumnFilter } from "components/Common/filters"
import { useEffect } from "react"
import { useState } from "react"
import JobListGlobalFilter from "components/Common/GlobalSearchFilter"
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import readXlsxFile from "read-excel-file"
import useApi from "common/ApiMiddlewere"
import toast from "react-hot-toast"

const colourStyles = {
  option: (styles, { isDisabled, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
      color: isFocused ? "#fff" : "#495057",
      cursor: isDisabled ? "not-allowed" : "default",
      padding: "3px 10px",
    }
  },
  control: (styles, { isDisabled }) => {
    const updatedStyles = {
      ...styles,
      border: "1px solid  #ced4da",
      minHeight: "35px",
      padding: "3px 10px",
      fontSize: "12px",
    }
    return updatedStyles
  },
}

let Leads = []
// Define a default UI for filtering
function GlobalFilter({
  setGlobalFilter,
  isJobListGlobalFilter,
  filterData,
  value,
  setValue,
}) {
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
    filterData(value)
  }, 200)

  return (
    <React.Fragment>
      <Col md={12}>
        <div className="search-box w-full d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Search this table
              </span>
              <input
                onChange={e => {
                  setValue(e.target.value)
                  onChange(e.target.value)
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={"Search…"}
                value={value || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </Col>
      {isJobListGlobalFilter && <JobListGlobalFilter />}
    </React.Fragment>
  )
}

const LeadTable = ({
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  className,
  filterData,
  pagePerSize,
  isLoading,
  TotalRecords,
  setdateDisble,
  dateDisble,
  date, setdate,
  leadStatus, setLeadStatus,
  handleLeadClick,
  isAddLeadList,
  setLeadTypeFilterValue,
  leadTypeFilterValue, leadType,
  selectedUser, setSelectedUser, users,
  writeDataToExcel, setScreenLoad, LeadListApi,
  dateFilter, setDateFilter
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageSize: 20,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useExpanded,
    usePagination
  )
  const handlesort = column => { }
  const [pageIndex, setpageIndex] = useState(1)
  const [prevValue, setPrevValue] = useState();

  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? "🔽" : "🔼") : ""
  }

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
  }

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0
    gotoPage(page)
  }

  const [isMobile, setisMobile] = useState(window.innerWidth < 924)
  const [value, setValue] = React.useState()
  const [isIpad, setIsIpad] = useState(window.innerWidth < 924)

  useEffect(() => {
    pagePerSize(pageSize, pageIndex, value)
    setPrevValue(value);
  }, [pageSize, value, pageIndex])

  useEffect(() => {
    if (value !== prevValue) {
      setpageIndex(1);
    }
  }, [value]);

  useEffect(() => {
    setpageIndex(1);
  }, [pageSize]);

  useEffect(() => {
    if (leadStatus) {
      setpageIndex(1);
    }
  }, [leadStatus]);


  const margin = {
    marginTop: isMobile ? "8px" : "28px",
  }

  const handleClick = () => {
    setdateDisble(!dateDisble);
  }
  const checkbox = useRef();
  const flatpickrRef = useRef(null);
  const inputRef = useRef(null)

  const { deleteApi, getApi, postApi, putApi } = useApi()

  const handleImportClick = () => {
    inputRef.current.click()
  }

  const handleImport = async $event => {
    Leads = []
    setScreenLoad(true)
    const files = $event.target.files
    readXlsxFile(files[0], { sheet: "Leads" }).then(rows => {
      for (let i = 1; i < rows.length; i++) {
        if (rows[i][0] != null) {
          let obj = {
            SrNo: rows[i][0],
            Name: rows[i][1] ? rows[i][1]?.toString() : null,
            ContactNo: rows[i][2] ? rows[i][2]?.toString() : null,
            LeadTypeName: rows[i][3] ? rows[i][3]?.toString() : null,
            Address: rows[i][4] == null ? "" : rows[i][4],
            Remark: rows[i][5] == null ? "" : rows[i][5],
          }
          Leads.push(obj)
        }
      }
      postApi("Lead/import-leads", Leads).then(({ data, status }) => {
        setScreenLoad(false)
        if (status === 200) {
          LeadListApi()
          toast.success("Successfully Imported Leads", {
            style: {
              fontSize: "15px",
            },
          })
        } else {
          toast.error(data, {
            style: {
              fontSize: "15px",
            },
          })
        }
      })
    })
  }

  return (
    <Fragment>
      <Row >
        <Col md="6">
          <Row>
            <Col md="4" className="table-header" style={margin}>
              <select
                className="form-select"
                value={pageSize}
                onChange={onChangeInSelect}
              >
                {[10, 20, 30, 40, 50].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </Col>
            <Col md="4" className="table-header" style={margin}>
              {isGlobalFilter && (
                <GlobalFilter
                  preGlobalFilteredRows={preGlobalFilteredRows}
                  globalFilter={state.globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  isJobListGlobalFilter={isJobListGlobalFilter}
                  filterData={filterData}
                  value={value}
                  setValue={setValue}
                />
              )}
            </Col>
            <Col md="4" className="table-header" style={margin}>
              <select
                className="form-select"
                value={leadStatus}
                onChange={e => setLeadStatus(e.target.value)}
              >
                <option value={0}>Select Status</option>
                <option value={1}>Lead</option>
                <option value={2}>Followup</option>
                <option value={3}>Convert</option>
                <option value={4}>Fail</option>

              </select>
            </Col>
          </Row>
        </Col>
        <Col md="4">
          <Row style={{ marginTop: isMobile ? "8px" : "9px", marginBottom: isMobile ? "10px" : "" }}>
            <div>
              <div className=" d-flex gap-2">
                <Input
                  type="radio"
                  value={true}
                  id="createDate"
                  className="form-check-input"
                  checked={dateFilter}
                  onClick={() => { setDateFilter(true) }}
                />
                <Label className="form-check-label font-size-13 me-2" htmlFor="createDate">
                  Created Date
                </Label>
                <Input
                  type="radio"
                  value={false}
                  id="followUpDate"
                  className="form-check-input"
                  checked={!dateFilter}
                  onClick={() => { setDateFilter(false) }}
                />
                <Label className="form-check-label font-size-13" htmlFor="followUpDate">
                  FollowUp Date
                </Label>
              </div>
            </div>
            <Col md={12} className="table-header" >
              <div className="d-flex" >
                <div className="form-control " onClick={() => handleClick()} style={{ width: "40px", borderRight: "none", backgroundColor: "#EFF2F7", display: "flex", alignItems: "center", cursor: "pointer" }}>
                  {/* <FormGroup check> */}
                  <input
                    id="checkbox"
                    type="checkbox"
                    style={{ width: "15px", height: "15px", cursor: "pointer" }}
                    // value={dateDisble}
                    checked={dateDisble}
                    onChange={e => setdateDisble(e.target.checked)}
                    ref={checkbox}
                  />
                  {/* </FormGroup> */}
                </div>
                <Flatpickr
                  ref={flatpickrRef}
                  disabled={!dateDisble}
                  className="form-control d-block"
                  placeholder="dd M,yyyy"
                  options={{
                    mode: "range",
                    dateFormat: "d-m-Y"
                  }}
                  value={date}
                  onChange={(e) => { setdate(e) }}

                />
                <i
                  className="fas fa-calendar-alt calander-icon"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    flatpickrRef.current.flatpickr.open();
                  }}
                ></i>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col md={5}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", marginBottom: isMobile ? "10px" : "" }}>
            {JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" &&
              <div style={{ width: "100%" }}>
                <Select
                  unstyled
                  styles={colourStyles}
                  value={selectedUser}
                  onChange={(e) => {
                    setSelectedUser(e)
                  }}
                  options={users}
                  className="select2-selection"
                />
              </div>}
            <div style={{ width: "100%" }}>
              <select
                className="form-select"
                value={leadTypeFilterValue}
                onChange={e => setLeadTypeFilterValue(e.target.value)}
              >
                <option value={0}>Select Lead Type</option>
                {leadType.map((item, index) => (
                  <option key={index} value={item.Key}>
                    {item.Value}
                  </option>
                ))}

              </select>
            </div>
          </div>
        </Col>

        <Col md={isMobile ? 12 : 7}>
          <div style={{ display: "flex", gap: "20px", textAlign: "end", justifyContent: "end" }}>
            <div>
              <div style={{ marginTop: "", textAlign: "end", padding: "0px" }}>
                <input
                  type="file"
                  name="file"
                  ref={inputRef}
                  className="custom-file-input"
                  style={{ display: "none" }}
                  id="inputGroupFile"
                  required
                  onChange={handleImport}
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <button
                  type="button"
                  className="btn btn-light  btn-label"
                  onClick={handleImportClick}
                >
                  <i className="far fa-file-excel label-icon"></i> Import
                </button>
                {/* <button
                  type="button"
                  className="btn btn-excel  btn-label"
                  onClick={handleImportClick}
                >
                  Import <i className="far fa-file-excel label-icon"></i>
                </button> */}
              </div>
            </div>
            <div>
              <div style={{ marginTop: "", textAlign: "end", padding: "0px" }}>
                {data.length > 0 ? (<button
                  type="button"
                  className="btn btn-excel  btn-label"
                  onClick={writeDataToExcel}
                >
                  Export <i className="far fa-file-excel label-icon"></i>
                </button>) : (<button
                  type="button"
                  className="btn  btn-excel  btn-label"
                  style={{ cursor: "not-allowed" }}
                >
                  Export <i className="far fa-file-excel label-icon"></i>
                </button>)}
              </div>
            </div>
            <div>
              {isAddLeadList && (
                <div className="text-sm-end">
                  <Button
                    type="button"
                    color="primary"
                    className="btn  mb-2 "
                    onClick={handleLeadClick}
                  >
                    <i className="mdi mdi-plus-circle-outline me-1" />
                    Create
                  </Button>
                </div>
              )}
            </div>
          </div>


        </Col>

        {/* <Col md={((isIpad && JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin") ? 12 : 2) || ((isIpad || JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin") ? 9 : 2)} style={{ marginTop: isMobile ? "8px" : "", marginBottom: isIpad ? "10px" : "", textAlign: "end" }}>
          <div className="d-flex" style={{ justifyContent: isIpad ? "start" : "end", gap: "15px", marginLeft: isIpad ? "6px" : "0px" }}>

          </div>
        </Col> */}
      </Row>

      <div className="table-responsive react-table">
        <Table bordered  {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    onClick={() => {
                      handlesort(column)
                    }}
                    {...column.getHeaderProps({
                      style: {
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth,
                        width: column.width,
                      },
                    })}
                  >
                    <div className={`mb-0`}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {page.length ? (
            <tbody {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr>
                      {row.cells.map(cell => {
                        return (
                          <td
                            key={cell.id}
                            className={`text-nowrap`}
                            {...cell.getCellProps({
                              style: {
                                minWidth: cell.minWidth,
                                maxWidth: cell.maxWidth,
                                width: cell.width,
                              },
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  </Fragment>
                )
              })}
            </tbody>
          ) : (
            <tbody
              style={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                height: "40px",
              }}
            >
              <tr>
                <td colSpan={headerGroups[0].headers.length}>
                  {isLoading ? "Loading..." : "No Record Found"}
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex - 1)}
              disabled={pageIndex == 1}
            >
              {"<<"}
            </Button>
            {/* <Button
              color="primary"
              onClick={previousPage}
              // disabled={!canPreviousPage}
            >
              {"<"}
            </Button> */}
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page
          <strong style={{ marginLeft: "5px" }}>
            {TotalRecords == 0 ? 1 : pageIndex} of {TotalRecords == 0 ? 0 : Math.ceil(TotalRecords / pageSize)}
          </strong> | Total <strong>{TotalRecords}</strong>
        </Col>
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            {/* <Button color="primary" onClick={nextPage} disabled={!canNextPage}> */}
            {/* <Button color="primary" onClick={pageIndex}>
              {">"}
            </Button> */}
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex + 1)}
              disabled={pageIndex == (pageIndex == 1 && TotalRecords == 0 ? Math.ceil(TotalRecords / pageSize) + 1 : Math.ceil(TotalRecords / pageSize))}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment >
  )
}

LeadTable.LeadopTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default LeadTable
